import { useMemo } from "react";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import {
  TimeBandXAxis,
  TimeBandXAxisOptions,
  TimeBandXAxisTimeUnit,
} from "./TimeBandXAxis";
import { XAxis } from "@mui/x-charts-premium";

export const useTimeBandXAxis = (
  timeUnit: TimeBandXAxisTimeUnit,
  startDate: DateTime<true>,
  endDate: DateTime<true>,
  options?: TimeBandXAxisOptions
): Array<XAxis> => {
  const { t } = useTranslation("shared-ts-mui");

  return useMemo(
    () => [TimeBandXAxis.resolve(timeUnit, startDate, endDate, t, options)],
    [startDate, timeUnit, endDate, options, t]
  );
};
